// extracted by mini-css-extract-plugin
export default {"root":"RelationshipsMapping_root__3meBf","tabs":"RelationshipsMapping_tabs__kyTzt"};